import { render, staticRenderFns } from "./UserInductions.vue?vue&type=template&id=3d4c390c&scoped=true"
import script from "./UserInductions.vue?vue&type=script&lang=js"
export * from "./UserInductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c390c",
  null
  
)

export default component.exports